import { useNavigate } from 'react-router';
import { Fragment } from 'react';

import { AuthHeading } from 'src/components/Layout';
import { Button } from '@/components/ui/button';

import { AddMemberForm, InviteMembers } from './ui';
import { useInvite } from './model';

const InitialActions = () => {
  const { createInvite } = useInvite();
  const navigate = useNavigate();

  const onSkip = () => navigate('/');

  return (
    <Fragment>
      <Button size="lg" className="w-full mb-4" onClick={createInvite}>
        Invite team members
      </Button>
      <Button variant="link" className="w-full" onClick={onSkip}>
        Skip for now
      </Button>
    </Fragment>
  );
};

const stepDataMap: Record<string, { component: React.ElementType; title: string; description: string }> = {
  initial: {
    component: InitialActions,
    title: 'Invite your team members',
    description:
      "We'll email them an invitation to join Codekeeper. They'll have access to any products you add them to. You can do this now or later in Settings.",
  },
  'add-members': {
    component: AddMemberForm,
    title: 'Create invitation',
    description: "Enter their details and assign them a role. We'll email them an invitation to join Codekeeper.",
  },
  'invite-members': {
    component: InviteMembers,
    title: 'Invite your team members',
    description:
      "We'll email them an invitation to join Codekeeper. They'll have access to any products you add them to. You can do this now or later in Settings.",
  },
};

const OnboardingInviteContainer = () => {
  const { step } = useInvite();

  const StepComponent = stepDataMap[step].component;
  const stepTitle = stepDataMap[step].title;
  const stepDescription = stepDataMap[step].description;

  return (
    <Fragment>
      <AuthHeading title={stepTitle} description={stepDescription} />
      {StepComponent && <StepComponent />}
    </Fragment>
  );
};

export default OnboardingInviteContainer;
